import React, { Component } from 'react'
import Media from 'react-media'
import { connect } from 'react-redux'

import SmallProfile from './small_profile'
import BigProfile from './big_profile'


class CreateServiceJob extends Component{

    render(){
        return(
            <>
                <Media query={{ maxWidth: 767}}>
                    {matches => matches ? 
                        <SmallProfile/> : <BigProfile/>
                    }
                </Media>
            </>
        )
    }
}

export default connect(
    null,
    {  }
)(CreateServiceJob)